/**
 * Sidebar nav grouping for base footer steps (#1330).
 */

export const REQUEST_FORM_FOOTER_STEP_IDS = ['documents', 'summary'] as const;

export type RequestFormFooterStepId =
  (typeof REQUEST_FORM_FOOTER_STEP_IDS)[number];

export function isFooterRequestFormStepId(stepId: string): boolean {
  return (REQUEST_FORM_FOOTER_STEP_IDS as readonly string[]).includes(stepId);
}

export function partitionSidebarNavSteps<T extends { id: string }>(
  steps: readonly T[],
): { primarySteps: T[]; footerSteps: T[] } {
  const footerSet = new Set<string>(REQUEST_FORM_FOOTER_STEP_IDS);
  const primarySteps: T[] = [];
  const footerSteps: T[] = [];

  for (const step of steps) {
    if (footerSet.has(step.id)) {
      footerSteps.push(step);
    } else {
      primarySteps.push(step);
    }
  }

  return { primarySteps, footerSteps };
}
